import Cookies from "js-cookie";

const TokenKey = "Admin-Token";
const RefreshTokenKey = "Admin-Refresh-Token";

export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  return Cookies.set(TokenKey, token);
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}

export function getRefreshToken() {
  return Cookies.get(RefreshTokenKey);
}

export function setRefreshToken(token) {
  return Cookies.set(RefreshTokenKey, token);
}

export function removeRefreshToken() {
  return Cookies.remove(RefreshTokenKey);
}



// WEBPACK FOOTER //
// ./src/axios/setToken.js